var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 15
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "warning_svg__a",
    d: "M15.582 10.493l-5.295-9.17A2.652 2.652 0 007.997 0c-.94 0-1.818.507-2.289 1.323L.353 10.597a2.652 2.652 0 000 2.644 2.653 2.653 0 002.29 1.323h10.713l.022-.001a2.646 2.646 0 002.204-4.07zM7.07 3.36h1.96c.149 0 .27.09.27.203l-.54 5.582c0 .112-.122.203-.27.203h-.88c-.148 0-.27-.09-.27-.203L6.8 3.563c0-.112.121-.203.27-.203zM8 12.72a1.28 1.28 0 110-2.56 1.28 1.28 0 010 2.56z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FFAA20",
    fillRule: "evenodd",
    xlinkHref: "#warning_svg__a"
  })));
}
export default SvgWarning;